import React, { useContext, useEffect } from 'react';
import ConfigDataProvider, {
	ConfigDataContext,
} from '../../../shared/providers/ConfigDataProvider';
import { GET_CONFIG_DATA } from '../../../shared/reducer';

const CherryBorders = () => (
	<ConfigDataProvider>
		<CherryBordersConsumer />
	</ConfigDataProvider>
);

const CherryBordersConsumer = () => {
	const { state, dispatch } = useContext(ConfigDataContext);
	useEffect(() => {
		dispatch({
			type: GET_CONFIG_DATA,
			id: 'RentReductionCherryBorders',
			private: true,
		});
	}, []);
	return <pre>Cherry borders: {JSON.stringify(state, null, 4)}</pre>;
};

export default CherryBorders;
